import Vue from 'vue'
import VueX from 'vuex'
import getters from "./getters";
import actions from "@/store/actions";
import mutations from "@/store/mutations";


Vue.use(VueX)
const state = {
  baseUrl: 'http://210.72.89.21',
  openLoginBox:false,
  // access_token: localStorage.getItem('access_token') ? localStorage.getItem('access_token') : '',
  // refresh_token:localStorage.getItem('refresh_token') ? localStorage.getItem('refresh_token'):'',
  // expires_in:localStorage.getItem('expires_in') ? localStorage.getItem('expires_in'):'',
  // user_info:localStorage.getItem('user_info') ? localStorage.getItem('user_info'):'',
  // user_menu:localStorage.getItem('user_menu') ? localStorage.getItem('user_menu'):[{path:'/services',title:'服务事项'}],
  // certification: localStorage.getItem('certification') ? localStorage.getItem('certification') : '',
  toSave: {},
  isLogout: false,
  priviewUrl: 'http://192.168.0.116:8886',
  /*路由权限*/

}
const store = new VueX.Store({
  state,
  getters,
  actions,
  mutations,
  modules:{

  }

})

export default store


// export default new Vuex.Store({
//   state: {
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   }
// })
